module.exports = __webpack_public_path__ + "img/ico-share01.51ad3afc.svg";